import type { ApiTmpStorageId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { SalaryApiTmpStorage } from './types/SalaryApiTmpStorage';

type ApiResponse = {
  data: string;
};

function mapResponse(response: ApiResponse) {
  const parsedData = JSON.parse(
    response.data,
  ) as unknown as SalaryApiTmpStorage | null;

  if (parsedData?.type !== 'survey-report') return null;

  return parsedData;
}

const endpoint = new FetchEndpoint({
  urlFactory: (tmpStorageId: ApiTmpStorageId) =>
    `/data/tmp-storage/${tmpStorageId}`,
  mapResponse,
});

// Exports

export const salaryApiIsomorphicFetchTmpStorage =
  endpoint.createIsomorphicFetchFn();
